import { useState, useEffect } from 'react';
import { haalMijnDiensten } from '../lib/api.js';
import { datumNL } from '../lib/datum.js';

// Herbruikbare "kies een van je eigen komende diensten"-lijst. Haalt de diensten via
// haalMijnDiensten (identiteit uit token) en toont ze als klikbare kaarten. onKies(dienst)
// bij een keuze; optionele onSluit voor een Annuleren-affordance.
export default function DienstKiezer({ onKies, onSluit }) {
  const [diensten, setDiensten] = useState([]);
  const [laden, setLaden] = useState(false);
  const [fout, setFout] = useState(null);

  useEffect(() => {
    let geannuleerd = false;

    const laad = async () => {
      setLaden(true);
      setFout(null);
      setDiensten([]);
      try {
        const res = await haalMijnDiensten();
        if (!geannuleerd) setDiensten(res.diensten || []);
      } catch (err) {
        if (!geannuleerd) setFout(err.message);
      } finally {
        if (!geannuleerd) setLaden(false);
      }
    };
    laad();

    return () => { geannuleerd = true; };
  }, []);

  return (
    <div className="space-y-3">
      {laden && <p className="text-sm text-slate-500">Diensten laden…</p>}
      {!laden && fout && <p className="text-sm text-red-600">{fout}</p>}
      {!laden && !fout && diensten.length === 0 && (
        <p className="text-sm text-slate-500">Je hebt geen komende diensten om te ruilen.</p>
      )}
      {!laden && !fout && diensten.map((d) => (
        <button
          key={`${d.datum}-${d.gemeenteKey}-${d.dienstId}`}
          onClick={() => onKies(d)}
          className="w-full text-left rounded-xl border border-slate-200 hover:border-brand-300 hover:bg-brand-50/40 p-3 transition-colors"
        >
          <div className="text-sm font-medium text-slate-800">{datumNL(d.datum)}</div>
          <div className="text-xs text-slate-500 mt-0.5">{d.dienstLabel} · {d.gemeenteLabel}</div>
        </button>
      ))}
      {onSluit && (
        <button onClick={onSluit} className="text-xs text-slate-500 hover:text-slate-700">
          Annuleren
        </button>
      )}
    </div>
  );
}
